import { createApp } from "vue";
import { upperFirst, camelCase } from "lodash";

const app = createApp({});
const requireComponent = require.context("@/components/", true, /.vue$/);

requireComponent.keys().forEach((fileName) => {
  const componentConfig = requireComponent(fileName);
  const componentName = upperFirst(
    camelCase(
      fileName
        .split("/")
        .pop()
        .replace(/\.\w+$/, "")
    )
  );

  app.component(componentName, componentConfig.default || componentConfig);
});

app.mount("#app");

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("form").forEach((form) => {
    const select = form.querySelector("select[data-sync]");
    const hidden = form.querySelector(`input[name="${select.dataset.sync}"]`);

    if (!select || !hidden) return;

    select.addEventListener("change", () => {
      hidden.value = select.options[select.selectedIndex].text;
    });
  });
});

(function () {
  document.querySelectorAll(".js-turnstile-form").forEach((form) => {
    const submitBtn = form.querySelector(".submit-btn");
    let token = null;

    const ok = (t) => {
      token = t;
      submitBtn.disabled = false;
    };
    const expired = () => {
      token = null;
      submitBtn.disabled = true;
    };
    const error = () => {
      token = null;
      submitBtn.disabled = true;
    };

    const id = Math.random().toString(36).substring(2, 9);
    window[`onOk_${id}`] = ok;
    window[`onExp_${id}`] = expired;
    window[`onErr_${id}`] = error;

    const widget = form.querySelector(".cf-turnstile");
    widget.setAttribute("data-callback", `onOk_${id}`);
    widget.setAttribute("data-expired-callback", `onExp_${id}`);
    widget.setAttribute("data-error-callback", `onErr_${id}`);

    form.addEventListener("submit", (e) => {
      if (!token) e.preventDefault();
    });
  });
})();
